import { render, staticRenderFns } from "./Index_.vue?vue&type=template&id=17040cd7&"
import script from "./Index_.vue?vue&type=script&lang=js&"
export * from "./Index_.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17040cd7')) {
      api.createRecord('17040cd7', component.options)
    } else {
      api.reload('17040cd7', component.options)
    }
    module.hot.accept("./Index_.vue?vue&type=template&id=17040cd7&", function () {
      api.rerender('17040cd7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/documents/Index_.vue"
export default component.exports